/**
 * @file registry.ts
 * @description Панель по виду элемента секции (phase19.16 Р2; OCP — реестр
 * вместо ветвления): новый вид элемента в shared — новая запись здесь;
 * сопоставленный тип не даст собрать кабинет без панели для вида.
 */

import type { SectionElementKind } from "@chaiberi/shared";
import type { ComponentType } from "react";

import { AnnouncementsElementPanel } from "./AnnouncementsElementPanel";
import { ButtonElementPanel } from "./ButtonElementPanel";
import { StatsPanel, TablePanel } from "./DataElementPanels";
import { ArticlesPanel, ReviewsPanel } from "./CatalogElementPanels";
import { CategoriesPanel } from "./CategoriesPanel";
import { ImageElementPanel } from "./ImageElementPanel";
import { ContactsPanel, FaqPanel, NewsletterPanel } from "./InfoElementPanels";
import { AudioPanel, GalleryPanel, VideoPanel } from "./MediaElementPanels";
import { ProductsElementPanel } from "./ProductsElementPanel";
import { ProductDescriptionPanel, ProductFactsPanel, ProductSellerPanel, ProductSpecsPanel, ProductTagsPanel } from "./product/ProductInfoPanels";
import { ProductRelatedPanel, ProductReviewsPanel } from "./product/ProductListPanels";
import { BreadcrumbsPanel, ProductBadgesPanel, ProductBuyPanel, ProductGalleryPanel, ProductShortPanel, ProductTitlePanel } from "./product/ProductMainPanels";
import { EyebrowPanel, HeadingPanel, TextPanel } from "./TextElementPanels";
import { TilesElementPanel } from "./TilesElementPanel";
import type { ElementPanelProps } from "./types";

export const ELEMENT_PANELS: { readonly [K in SectionElementKind]: ComponentType<ElementPanelProps<K>> } = {
  heading: HeadingPanel,
  eyebrow: EyebrowPanel,
  text: TextPanel,
  image: ImageElementPanel,
  gallery: GalleryPanel,
  video: VideoPanel,
  audio: AudioPanel,
  button: ButtonElementPanel,
  tiles: TilesElementPanel,
  products: ProductsElementPanel,
  categories: CategoriesPanel,
  articles: ArticlesPanel,
  reviews: ReviewsPanel,
  faq: FaqPanel,
  contacts: ContactsPanel,
  newsletter: NewsletterPanel,
  announcements: AnnouncementsElementPanel,
  stats: StatsPanel,
  table: TablePanel,
  // Р2а: элементы данных товара (шаблон страницы товара).
  breadcrumbs: BreadcrumbsPanel,
  "product-gallery": ProductGalleryPanel,
  "product-title": ProductTitlePanel,
  "product-buy": ProductBuyPanel,
  "product-badges": ProductBadgesPanel,
  "product-short": ProductShortPanel,
  "product-description": ProductDescriptionPanel,
  "product-facts": ProductFactsPanel,
  "product-specs": ProductSpecsPanel,
  "product-tags": ProductTagsPanel,
  "product-reviews": ProductReviewsPanel,
  "product-related": ProductRelatedPanel,
  "product-seller": ProductSellerPanel,
};
